import { render, staticRenderFns } from "./DlsjgCzjlList.vue?vue&type=template&id=28e7c62b"
import script from "./DlsjgCzjlList.vue?vue&type=script&lang=js"
export * from "./DlsjgCzjlList.vue?vue&type=script&lang=js"
import style0 from "./DlsjgCzjlList.vue?vue&type=style&index=0&id=28e7c62b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports